import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServiceProviderService {

  constructor(private http: HttpClient) { }
  createServiceProvider(data: any) {
    return this.http.post(`${environment.url}/users/service/create`, data);
  }
  checkBalanceAccount(data: any) {
    return this.http.post(`${environment.url}/users/payout/fundConfirmation`, data);
  }
  ybAccount(data: any) {
    return this.http.get(`${environment.url}/users/ybAccount/getList`, data);
  }

  getServiceBalance() {
    return this.http.get(`${environment.url}/users/service/getServiceBalance`);
  }
  getServiceProvider() {
    return this.http.get(`${environment.url}/users/service/getList`);
  }
  getAssignedService(id: any) {
    return this.http.get(`${environment.url}/users/service/getAssignedServices?id=${id}`);
  }
  getUsersProvider() {
    return this.http.get(`${environment.url}/users/getList`);
  }
  deleteServiceProvider(data: any) {
    return this.http.put(`${environment.url}/users/service/deleteDataById`, data);
  }

  getServiceProviderById(id: any) {
    return this.http.get(`${environment.url}/users/service/sa/${id}`);
  }
  editServiceProvider(id: any, data: any) {
    return this.http.put(`${environment.url}/users/service/updateById:${id}`, data);
  }
}
